import React, {useCallback, useRef} from 'react'
import {connect} from 'react-redux'
import {createStructuredSelector} from 'reselect'
import { useFormikContext, Formik, Form, Field } from 'formik';
import {Trans, useTranslation} from 'react-i18next'
import Yup from 'lib/yup'
import {Box, LabeledInput, LabeledCheckbox, Button} from 'components'
import {kevinAcceptPaymentAgreement, createClubPaymentMethod, updateClubPaymentMethod} from 'paymentMethods/actions'
import {
  getPaymentAgreementAccepted,
  getPaymentAgreementInfo,
} from 'paymentMethods/selectors'
import i18n from 'i18n'

const validationSchema = Yup.object().shape({
  accept: Yup.boolean().oneOf([true], i18n.t('mustBeAccepted')),
  bankName: Yup.string().required(),
  reg: Yup.number().typeError().required().max(9999),
  account: Yup.number().typeError().required(),
  bankContact: Yup.string(),
})

const initialValues = {
  accept: false,
  bankName: '',
  reg: '',
  account: '',
  bankContact: '',
}

const MobilepaySubscriptionAgreementForm =
  ({acceptPaymentAgreement, paymentAgreementInfo,
    paymentMethod, createClubPaymentMethod, updateClubPaymentMethod}) => {
  const [t] = useTranslation()
  const formikRef = useRef();

  const handleSubmit = useCallback(
    (values, {setSubmitting, setStatus}) => {
      new Promise((resolve, reject) => {
        setSubmitting(true)
        if (paymentMethod == null) {
          values.paymentMethodName = 'mobilepaysubscription';
          values.customClubPaymentMethodName = 'Mobilepay Subscription';
          createClubPaymentMethod({values, resolve, reject})
        } else {
          values.paymentMethodName = 'mobilepaysubscription';
          values.clubPaymentMethodInfoId = paymentMethod.clubPaymentMethodInfoId;
          updateClubPaymentMethod({values, resolve, reject})
        }
        
      }).then(() => {
        setSubmitting(false)
        setStatus('complete')
      })
    },
    [paymentMethod]
  )
  
  if (paymentMethod != null) {
    let customInfo = JSON.parse(paymentMethod.customInfo);

    if (formikRef.current) {
      formikRef.current.setFieldValue(
        "reg",
        customInfo.Reg
      );
      formikRef.current.setFieldValue(
        "account",
        customInfo.Account
      );
      formikRef.current.setFieldValue(
        "bankContact",
        customInfo.BankContact
      );
      formikRef.current.setFieldValue(
        "bankName",
        customInfo.BankName
      );

      formikRef.current.setFieldValue(
        "accept",
        customInfo.Accept
      );
    }
  }

  return (
    <Formik
      innerRef={formikRef}
      initialValues={{
        ...initialValues,
        ...paymentAgreementInfo,
      }}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({isValid, isSubmitting, status}) => (
        <Form>
          <Box mb={2}>
            <Field
              name="accept"
              component={LabeledCheckbox}
              label={() => (
                <>
                  <Trans i18nKey="acceptPaymentAgreement">
                    <strong>Godkend</strong> Mobilepay Abonnement foreningsaftale med MinForening *
                  </Trans>
                </>
              )}
            />
          </Box>
          <Box mb={2}>
            <Field
              name="bankName"
              component={LabeledInput}
              label={`${t('Pengeinstitut')}*`}
            />
          </Box>
          <Box mb={2}>
            <Field
              name="reg"
              component={LabeledInput}
              label={`${t('Registreringsnummer')}*`}
            />
          </Box>
          <Box mb={2}>
            <Field
              name="account"
              component={LabeledInput}
              label={`${t('Kontonummer')}*`}
            />
          </Box>
          <Box mb={2}>
            <Field
              name="bankContact"
              component={LabeledInput}
              label={`${t('Navn på kontaktperson i pengeinstitut')}*`}
            />
          </Box>
          <Button
            primary
            small
            type="submit"
            disabled={!isValid || isSubmitting}
          >
            {!status ? t('send') : t('send', {context: 'done'})}
          </Button>
        </Form>
      )}
    </Formik>
  )
}

const enhancer = connect(
  createStructuredSelector({
    paymentAgreementAccepted: getPaymentAgreementAccepted,
    paymentAgreementInfo: getPaymentAgreementInfo,
  }),
  {
    acceptPaymentAgreement: kevinAcceptPaymentAgreement.requested,
    createClubPaymentMethod: createClubPaymentMethod.requested,
    updateClubPaymentMethod: updateClubPaymentMethod.requested,
  }
)

export default enhancer(MobilepaySubscriptionAgreementForm)
